/**
 * Supported currencies and static exchange rates (Base: THB)
 * Rates as of Feb 2025 (Approximation)
 */
export const CURRENCIES = {
    thb: { code: 'THB', symbol: '฿', rate: 1, locale: 'th-TH' },
    usd: { code: 'USD', symbol: '$', rate: 0.028, locale: 'en-US' },
    eur: { code: 'EUR', symbol: '€', rate: 0.026, locale: 'de-DE' },
    jpy: { code: 'JPY', symbol: '¥', rate: 4.2, locale: 'ja-JP' },
    cny: { code: 'CNY', symbol: '¥', rate: 0.20, locale: 'zh-CN' },
    gbp: { code: 'GBP', symbol: '£', rate: 0.022, locale: 'en-GB' },
};

/**
 * Convert and format price
 * @param {number} amountInTHB - Price in Thai Baht
 * @param {string} targetCurrencyCode - 'thb', 'usd', etc.
 * @returns {string} Formatted price string
 */
export const formatPrice = (amountInTHB, targetCurrencyCode = 'thb') => {
    const currency = CURRENCIES[targetCurrencyCode] || CURRENCIES.thb;
    const convertedAmount = amountInTHB * currency.rate;

    return new Intl.NumberFormat(currency.locale, {
        style: 'currency',
        currency: currency.code,
        minimumFractionDigits: currency.code === 'THB' ? 0 : 2,
        maximumFractionDigits: currency.code === 'THB' ? 0 : 2,
    }).format(convertedAmount);
};
